import { SelectOption } from '@catapultsports/referee-react';
import { AverageSetSummary } from 'oas';
import { shouldDisableOption } from 'reporting/components/compare-to-filter';
import { MATCH_DAY } from 'reporting/constants';

export interface TfFilterTagOptions {
    value: string;
    id: number | string;
    isSelected?: boolean;
    isDisabled?: boolean;
}

export const transformAverageSummary = (
    averageSummary: AverageSetSummary[],
    filterSideMenuDisplayTags: SelectOption[],
): TfFilterTagOptions[] => {
    return filterSideMenuDisplayTags.map((option) => ({
        ...option,
        isDisabled: option.id === MATCH_DAY ? false : shouldDisableOption(option.id, averageSummary ?? []),
    }));
};
